
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useApple } from '@/modules/apple/model/edit';
import { ROUTE_NAME_APPLE } from '@/modules/apple/router';

export default defineComponent({
    name: ROUTE_NAME_APPLE,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useApple();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
